import { render, staticRenderFns } from "./JobCardOptimized.vue?vue&type=template&id=12677015"
import script from "./JobCardOptimized.vue?vue&type=script&lang=js"
export * from "./JobCardOptimized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports